import React from "react";
import OverviewPageDropdowns from "./OverviewPageDropdowns";
import ContentForPage from "../../containers/ContentForPage";
import PageLayout from "../UI/PageLayout";

const OverviewPage = () => {
  return (
    <PageLayout
      title="Overview"
      dropdowns={<OverviewPageDropdowns />}
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <ContentForPage pageName={"overview"} />
        </div>
      }
    />
  );
};

export default OverviewPage;
